/** Gudslip promotions: isolated scratch UI; no codes, discount mutations or Scratch Win event. */
(function () {
  'use strict';
  if (window.gudslipPromoRuntime) { window.gudslipPromoRuntime.init(); return; }
  var instances = new Map();
  function get(k) { try { return localStorage.getItem(k); } catch (_) { return null; } }
  function put(k, v) { try { localStorage.setItem(k, v); } catch (_) {} }
  function initRoot(root) {
    if (instances.has(root) || root.dataset.enabled !== 'true') return;
    var designMode = root.dataset.designMode === 'true';
    var campaign = root.dataset.campaign || 'promociones';
    var key = 'iurop:promo:' + campaign;
    var controller = new AbortController();
    var timers = new Set();
    var destroyed = false, opened = false, completed = false, revealed = false, busy = false;
    var lastFocus, paintReady = false, ctx, strokes = 0;
    var card = root.querySelector('[data-promo-card]');
    var canvas = root.querySelector('[data-promo-canvas]');
    var form = root.querySelector('[data-promo-form]');
    var error = root.querySelector('[data-promo-error]');
    var success = root.querySelector('[data-promo-success]');
    var title = root.querySelector('[data-promo-title]');
    var subtitle = root.querySelector('[data-promo-subtitle]');
    var submit = root.querySelector('[data-promo-submit]');
    var company = (root.dataset.klaviyoKey || '').trim();
    var list = (root.dataset.klaviyoList || '').trim();
    function on(el, name, fn) { el.addEventListener(name, fn, { signal: controller.signal }); }
    function later(fn, delay) {
      var id = setTimeout(function () { timers.delete(id); if (!destroyed) fn(); }, delay);
      timers.add(id); return id;
    }
    function close(record) {
      opened = false;
      root.classList.remove('is-open');
      root.hidden = true;
      document.documentElement.classList.remove('gudslip-promo-open');
      if (record && !designMode && !completed) put(key + ':snooze', String(Date.now() + (Number(root.dataset.snoozeDays) || 7) * 864e5));
      if (lastFocus && lastFocus.isConnected) lastFocus.focus();
    }
    function reveal() {
      if (revealed || !opened) return;
      revealed = true;
      card.classList.add('is-revealed');
      root.querySelector('[data-promo-prize]').removeAttribute('aria-hidden');
      canvas.tabIndex = -1;
      canvas.setAttribute('aria-hidden', 'true');
      title.hidden = true;
      subtitle.hidden = true;
      form.hidden = false;
      if (window.matchMedia('(min-width: 750px)').matches) root.querySelector('[data-promo-email]').focus();
    }
    function setupCanvas(attempt) {
      if (paintReady || revealed || !opened) return;
      var r = card.getBoundingClientRect();
      if (!r.width || !r.height) { if (attempt < 10) later(function () { setupCanvas(attempt + 1); }, 100); else reveal(); return; }
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      canvas.width = Math.round(r.width * dpr); canvas.height = Math.round(r.height * dpr);
      ctx = canvas.getContext('2d');
      if (!ctx) { reveal(); return; }
      var gold = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
      gold.addColorStop(0, '#d8c29a'); gold.addColorStop(0.5, '#eadbc0'); gold.addColorStop(1, '#d8c29a');
      ctx.fillStyle = gold; ctx.fillRect(0, 0, canvas.width, canvas.height);
      function paintLabel() {
        var label = (canvas.dataset.scratchLabel || '').toLocaleUpperCase(document.documentElement.lang || 'en');
        var size = canvas.width * 0.1;
        var family = getComputedStyle(title).fontFamily;
        ctx.font = '600 ' + size + 'px ' + family;
        while (size > canvas.width * 0.04 && ctx.measureText(label).width > canvas.width * 0.86) {
          size -= 1; ctx.font = '600 ' + size + 'px ' + family;
        }
        ctx.fillStyle = '#1f2447'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText(label, canvas.width / 2, canvas.height / 2);
      }
      paintLabel();
      paintReady = true;
      if (!canvas.dataset.foil) return;
      var img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = function () {
        if (!destroyed && !revealed && strokes === 0) { ctx.drawImage(img, 0, 0, canvas.width, canvas.height); paintLabel(); }
      };
      img.src = canvas.dataset.foil;
    }
    function open() {
      if (opened || destroyed || root.dataset.enabled !== 'true') return;
      opened = true; lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('gudslip-promo-open');
      root.querySelectorAll('.gudslip-promo__bg').forEach(function (img) { img.loading = 'eager'; });
      title.focus();
      later(function () { root.classList.add('is-open'); setupCanvas(0); }, 30);
    }
    var scratching = false, lastPoint = null;
    function point(e) {
      var r = canvas.getBoundingClientRect();
      return { x: (e.clientX - r.left) * canvas.width / r.width, y: (e.clientY - r.top) * canvas.height / r.height };
    }
    function scratch(p) {
      if (!paintReady || revealed) return;
      ctx.globalCompositeOperation = 'destination-out'; ctx.lineWidth = canvas.width * 0.14; ctx.lineCap = 'round';
      ctx.beginPath(); ctx.moveTo((lastPoint || p).x, (lastPoint || p).y); ctx.lineTo(p.x, p.y); ctx.stroke();
      lastPoint = p; strokes++;
    }
    function inspect(force) {
      if (!paintReady || revealed || (!force && strokes % 6)) return;
      try {
        var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data, clear = 0, total = 0;
        for (var i = 3; i < data.length; i += 32) { total++; if (data[i] === 0) clear++; }
        if (total && clear / total >= 0.45) reveal();
      } catch (_) { reveal(); }
    }
    on(canvas, 'pointerdown', function (e) {
      if (!paintReady || revealed) return;
      scratching = true; lastPoint = null; scratch(point(e)); canvas.setPointerCapture(e.pointerId);
    });
    on(canvas, 'pointermove', function (e) { if (scratching) { e.preventDefault(); scratch(point(e)); inspect(false); } });
    on(canvas, 'pointerup', function () { scratching = false; lastPoint = null; inspect(true); });
    on(canvas, 'pointercancel', function () { scratching = false; lastPoint = null; });
    on(canvas, 'keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); reveal(); } });
    on(root.querySelector('[data-promo-close]'), 'click', function () { close(true); });
    on(root.querySelector('[data-promo-shop]'), 'click', function () { close(false); });
    on(document, 'keydown', function (e) {
      if (!opened) return;
      if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
      if (e.key !== 'Tab') return;
      var focusable = Array.from(root.querySelectorAll('button:not([disabled]), input, select, a[href], [tabindex="0"]'))
        .filter(function (el) { return !el.closest('[hidden]') && el.getClientRects().length && el.tabIndex >= 0; });
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) { e.preventDefault(); if (last) last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !root.contains(document.activeElement))) { e.preventDefault(); if (first) first.focus(); }
    });
    function countryData() {
      var code = root.dataset.countryCode || '', name = root.dataset.countryName || code;
      try { name = new Intl.DisplayNames(['en'], { type: 'region' }).of(code); } catch (_) {}
      return { code: code, name: name };
    }
    function capture(email, country) {
      var attributes = {
        email: email,
        properties: {
          'Promotion Source': 'Gudslip promotions popup', 'Promotion Campaign': campaign,
          'Promotion Email Consent': true, 'Promotion Consent At': new Date().toISOString()
        }
      };
      if (country.code) {
        attributes.location = { country: country.name };
        attributes.properties.country = country.name;
        attributes.properties.country_code = country.code;
      }
      var language = (root.dataset.languageCode || '').trim();
      if (language) attributes.properties.language = language;
      attributes.subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
      var payload = { data: {
        type: 'subscription',
        attributes: { custom_source: 'Gudslip promotions popup', profile: { data: { type: 'profile', attributes: attributes } } },
        relationships: { list: { data: { type: 'list', id: list } } }
      } };
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
        body: JSON.stringify(payload), signal: controller.signal
      }).then(function (response) { if (!response.ok) throw new Error('capture rejected'); });
    }
    on(form, 'submit', function (e) {
      e.preventDefault(); if (busy || !revealed || form.hidden) return;
      error.hidden = true;
      if (!form.reportValidity()) return;
      var email = root.querySelector('[data-promo-email]').value.trim();
      var country = countryData();
      if (!company || !list) { error.textContent = form.dataset.errorText; error.hidden = false; return; }
      busy = true; submit.disabled = true;
      // Theme editor preview never creates contacts or subscriptions.
      (designMode ? Promise.resolve() : capture(email, country)).then(function () {
        if (destroyed) return;
        completed = true; busy = false;
        if (!designMode) put(key + ':done', '1');
        form.hidden = true; card.hidden = true; subtitle.hidden = true;
        root.classList.add('is-success'); success.hidden = false;
        root.setAttribute('aria-labelledby', success.querySelector('[tabindex]').id);
        success.querySelector('[tabindex]').focus();
      }).catch(function () {
        if (destroyed) return;
        busy = false; submit.disabled = false; error.textContent = form.dataset.errorText; error.hidden = false;
      });
    });
    function cookieBannerVisible() {
      if (document.body.classList.contains('has-cookie-banner')) return true;
      var banner = document.querySelector('.shopify-pc__banner');
      return !!(banner && !banner.hidden && banner.getClientRects().length && getComputedStyle(banner).display !== 'none');
    }
    function schedule() {
      if (get(key + ':done') === '1' || Date.now() < Number(get(key + ':snooze'))) return;
      if (cookieBannerVisible()) { later(schedule, 500); return; }
      later(function () { if (cookieBannerVisible()) schedule(); else open(); }, Math.max(0, Number(root.dataset.delay) || 0) * 1000);
    }
    if (designMode) {
      on(document, 'shopify:section:select', function (e) { if (e.target.contains(root)) open(); });
      on(document, 'shopify:section:deselect', function (e) { if (e.target.contains(root)) close(false); });
    } else schedule();
    instances.set(root, function () { destroyed = true; controller.abort(); timers.forEach(clearTimeout); close(false); instances.delete(root); });
  }
  function init() { document.querySelectorAll('[data-promo-popup]').forEach(initRoot); }
  window.gudslipPromoRuntime = { init: init };
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (e) {
    instances.forEach(function (destroy, root) { if (e.target.contains(root)) destroy(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
